import gql from 'graphql-tag';

export default {
    createProfileMutation: gql`
        mutation CreateProfile($name: String!, $plan: String) {
            createProfile(name: $name, plan: $plan) {
                id
                url
            }
        }
    `,
};
